module.exports = __webpack_public_path__ + "assets/img/EmptyTasks@3x.0428fa4b.png";